import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { MrfEmployeeListComponent } from './mrf-employee-list/mrf-employee-list.component';
import { CreatekicketComponent } from './createkicket/createkicket.component';
import { TicketmasterComponent } from './ticketmaster/ticketmaster.component';
import { EmployeeprofileComponent } from './employeeprofile/employeeprofile.component';
import { EmployeemasterComponent } from './employeemaster/employeemaster.component';
import { EmployeeattendanceComponent } from './employeeattendance/employeeattendance.component';
import { AdminAttendanceComponent } from './admin-attendance/admin-attendance.component';
import { SpeakUpComponent } from './speak-up/speak-up.component';
import { TemplatesComponent } from './templates/templates.component';
import { ReleaseComponent } from './release/release.component';
import { ExitManagmentComponent } from './exit-managment/exit-managment.component';
import { JoiningDashboardComponent } from './joining-dashboard/joining-dashboard.component';
import { InducationComponent } from './pages/inducation/inducation.component';
import { EsicComponent } from './pages/esic/esic.component';
import { MediclaimsComponent } from './pages/mediclaims/mediclaims.component';
import { EducationKitComponent } from './pages/education-kit/education-kit.component';
import { Covid19Component } from './pages/covid19/covid19.component';
import { SiteManagerBuddyComponent } from './site-manager-buddy/site-manager-buddy.component';
import { EmployeeJoiningKitComponent } from './pages/employee-joining-kit/employee-joining-kit.component';
import { EapComponent } from './pages/eap/eap.component';
import { GratuityComponent } from './pages/gratuity/gratuity.component';
import { BirthdayComponent } from './pages/birthday/birthday.component';
import { ExpensesComponent } from './expenses/expenses.component';
import { NewExpensesComponent } from './new-expenses/new-expenses.component';
import { NewReportComponent } from './new-report/new-report.component';
import { MicroloanComponent } from './microloan/microloan.component';
import { WorkplacePermissionComponent } from './workplace-permission/workplace-permission.component';
import { DownloadQrCodeComponent } from './download-qr-code/download-qr-code.component';
import { MediclaiminformationComponent } from './mediclaiminformation/mediclaiminformation.component';
import { MinimumwageComponent } from './minimumwage/minimumwage.component';
import { SelfCovidDeclarationFormComponent } from './self-covid-declaration-form/self-covid-declaration-form.component';
import { VaccinReqFormComponent } from './pages/vaccin-req-form/vaccin-req-form.component';

import { IJPSGADashboardComponent } from './pages/ijp-sga-dashboard/ijp-sga-dashboard.component';
import { VaccinationCampTrackerComponent } from './pages/vaccination-camp-tracker/vaccination-camp-tracker.component';
import { WorkplacePermissionDashboardComponent } from './pages/workplace-permission-dashboard/workplace-permission-dashboard.component';
import { SPOCCenterDashboardComponent } from './pages/spoccenter-dashboard/spoccenter-dashboard.component';
import { FnfDashboardComponent } from './pages/fnf-dashboard/fnf-dashboard.component';
import { MRFOnHoldComponent } from './pages/mrfon-hold/mrfon-hold.component';
import { PayrollManagementDashboardComponent } from './pages/payroll-management-dashboard/payroll-management-dashboard.component';
import { RBCCompletionDashboardComponent } from './pages/rbccompletion-dashboard/rbccompletion-dashboard.component';
import { IndiaTaDashboardComponent } from './pages/india-ta-dashboard/india-ta-dashboard.component';
import { WpdIvrDashboardComponent } from './pages/wpd-ivr-dashboard/wpd-ivr-dashboard.component';
import { SeatAvailabilityComponent } from './pages/seat-availability/seat-availability.component';
import { HyderabadComponent } from './pages/hyderabad/hyderabad.component';
import { ChennaiComponent } from './pages/chennai/chennai.component';
import { NoidaComponent } from './pages/noida/noida.component';
import { PuneComponent } from './pages/pune/pune.component';
import { GoregaonComponent } from './pages/goregaon/goregaon.component';
import { MaladComponent } from './pages/malad/malad.component';
import { AccommodationComponent } from './pages/accommodation/accommodation.component';
import { ChartComponent } from './pages/chart/chart.component';
import { ApprovalsComponent } from './pages/approvals/approvals.component';
import { FoodOrderComponent } from './food-order/food-order.component';
import { FoodOrderListComponent } from './food-order-list/food-order-list.component';
import { TravalBookingComponent } from './traval-booking/traval-booking.component';
import { TravalContractlistComponent } from './pages/traval-contractlist/traval-contractlist.component';
import { TravalSearchComponent } from './pages/traval-search/traval-search.component';
import { NewdashboardComponent } from './newdashboard/newdashboard.component';
import { NewsLandingPageComponent } from './admin/components/news-landing-page/news-landing-page.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    pathMatch: 'full',
  },
  {
    path: 'joinings',
    component: JoiningDashboardComponent,
  },
  {
    path: 'mrfemployeelist',
    component: MrfEmployeeListComponent,
  },
  {
    path: 'createticket',
    component: CreatekicketComponent,
  },
  {
    path: 'ticketmaster',
    component: TicketmasterComponent,
  },
  {
    path: 'employeeprofile',
    component: EmployeeprofileComponent,
  },
  {
    path: 'employeemaster',
    component: EmployeemasterComponent,
  },
  {
    path: 'employeeattendance',
    component: EmployeeattendanceComponent,
  },
  {
    path: 'adminattendance',
    component: AdminAttendanceComponent,
  },
  {
    path: 'speakUp',
    component: SpeakUpComponent,
  },
  {
    path: 'templates',
    component: TemplatesComponent,
  },
  {
    path: 'release',
    component: ReleaseComponent,
  },
  {
    path: 'exit',
    component: ExitManagmentComponent,
  },
  {
    path: 'inducation',
    component: InducationComponent,
  },
  {
    path: 'esic',
    component: EsicComponent,
  },
  {
    path: 'mediclaims',
    component: MediclaimsComponent,
  },
  {
    path: 'educationkit',
    component: EducationKitComponent,
  },
  {
    path: 'covid19',
    component: Covid19Component,
  },
  {
    path: 'site-manager-buddy',
    component: SiteManagerBuddyComponent,
  },
  {
    path: 'employeekit',
    component: EmployeeJoiningKitComponent,
  },
  {
    path: 'eap',
    component: EapComponent,
  },
  {
    path: 'Gratuity',
    component: GratuityComponent,
  },
  {
    path: 'birthday',
    component: BirthdayComponent,
  },
  {
    path: 'expenses',
    component: ExpensesComponent,
  },
  {
    path: 'addexpence',
    component: NewExpensesComponent,
  },
  {
    path: 'expensereport',
    component: NewReportComponent,
  },
  {
    path: 'microloan',
    component: MicroloanComponent,
  },
  {
    path: 'workplace-permission',
    component: DownloadQrCodeComponent,
  },
  {
    path: 'apply-workplace',
    component: WorkplacePermissionComponent,
  },
  {
    path: 'mediclaim-info',
    component: MediclaiminformationComponent,
  },
  {
    path: 'minimum-wage',
    component: MinimumwageComponent,
  },
  {
    path: 'self-covid-register',
    component: SelfCovidDeclarationFormComponent,
  },
  {
    path: 'ijp-sga-dashboard',
    component: IJPSGADashboardComponent,
  },
  {
    path: 'vaccination-dashboard',
    component: VaccinationCampTrackerComponent,
  },
  {
    path: 'workplace-permision-dashboard',
    component: WorkplacePermissionDashboardComponent,
  },
  {
    path: 'Center-SPOC-dashboard',
    component: SPOCCenterDashboardComponent,
  },
  {
    path: 'fnf-dashboard',
    component: FnfDashboardComponent,
  },
  {
    path: 'mrf-on-hold',
    component: MRFOnHoldComponent,
  },
  {
    path: 'payroll-management-dashboard',
    component: PayrollManagementDashboardComponent,
  },
  {
    path: 'rbc-completion-dashboard',
    component: RBCCompletionDashboardComponent,
  },
  {
    path: 'india-ta-dashboard',
    component: IndiaTaDashboardComponent,
  },
  {
    path: 'wpd-ivr-dashboard',
    component: WpdIvrDashboardComponent,
  },
  {
    path: 'ahmedabad_floor',
    component: SeatAvailabilityComponent,
  },
  {
    path: 'hyderabad_floor',
    component: HyderabadComponent,
  },
  {
    path: 'chennai_floor',
    component: ChennaiComponent,
  },
  {
    path: 'noida_floor',
    component: NoidaComponent,
  },
  {
    path: 'pune_floor',
    component: PuneComponent,
  },
  {
    path: 'Goregaon_floor',
    component: GoregaonComponent,
  },
  {
    path: 'malad_floor',
    component: MaladComponent,
  },
  {
    path: 'accommodation_list',
    component: AccommodationComponent,
  },
  {
    path: 'chart',
    component: ChartComponent,
  },
  {
    path: 'approvals',
    component: ApprovalsComponent,
  },
  {
    path: 'vacc-req',
    component: VaccinReqFormComponent,
  },
  {
    path: 'food-order',
    component: FoodOrderComponent,
  },
  {
    path: 'food-order-list',
    component: FoodOrderListComponent,
  },
  {
    path: 'traval-booking',
    component: TravalBookingComponent,
  },
  {
    path: 'traval-contract-list',
    component: TravalContractlistComponent,
  },
  {
    path: 'traval-search',
    component: TravalSearchComponent,
  },
  {
    path: 'newdashboard',
    component: NewdashboardComponent,
  },
  {
    path: 'news-landing-page',
    component: NewsLandingPageComponent,
  },
  {
    path: 'news-landing-page/:id/:txnId',
    component: NewsLandingPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DasboardRoutingModule {}
